import React from "react";
import style from "./AddSenderButton.module.css";
import classnames from "classnames";
import { Button } from "@my-scoot/component-library-legacy";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import LockIcon from "@material-ui/icons/Lock";
import { app_pathnames, app_route_keys } from "constants/urlPaths";
import { email_sender_ids } from "features/Integration/constants/Integration.constants";
import { useESUnlockModalStore } from "features/Integration/modules/EmailSenderUnlockModal/store/useESUnlockModalStore";

export const AddSenderButton = ({ isWhitelabelActive }) => {
  const setModalOpen = useESUnlockModalStore((store) => store.setModalOpen);

  const openInfoModal = () => {
    setModalOpen(true);
  };

  const redirectEmailSender = () => {
    window.location.href = `${window.location.origin}/#${app_pathnames[
      app_route_keys.integration_details
    ]({
      slug: email_sender_ids,
    })}`;
  };

  return (
    <Button
      color="secondary"
      className={classnames(
        style.senderButton,
        !isWhitelabelActive ? style.senderButtonLock : null
      )}
      buttonWrapperClassName={style.senderButtonWrapper}
      onClick={isWhitelabelActive ? redirectEmailSender : openInfoModal}
      fullWidth
    >
      <div className="tw-flex tw-gap-2 tw-items-center tw-justify-center">
        {isWhitelabelActive ? (
          <AddCircleOutlineIcon fontSize="small" />
        ) : (
          <div className="tw-bg-[linear-gradient(124.63deg,_#FFD37E_3.13%,_#F7AD1E_106.11%)] tw-flex tw-justify-center tw-items-center tw-p-1 tw-rounded-[4px] tw-my-[2px]">
            <LockIcon className="!tw-text-base !tw-text-black" />
          </div>
        )}
        <div className="tw-text-[14px] tw-font-[500]">Add new sender</div>
      </div>
    </Button>
  );
};
